import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import type React from 'react';
interface PhotoImageProperties {
  alt: string;
  className?: string;
  height?: number | null;
  index: number;
  markLoaded: (index: number) => void;
  onClick?: React.MouseEventHandler<HTMLImageElement>;
  onError?: (event: React.SyntheticEvent<HTMLImageElement>) => void;
  registerImage: (index: number) => (node: HTMLImageElement | null) => void;
  src: string;
  style?: React.CSSProperties;
  width?: number | null;
}
export function PhotoImage(t0) {
  const $ = _c(28);
  const {
    index,
    src,
    alt,
    width,
    height,
    className,
    style,
    registerImage,
    markLoaded,
    onClick,
    onError
  } = t0;
  const widthValue = typeof width === "number" && width > 0 ? width : undefined;
  const heightValue = typeof height === "number" && height > 0 ? height : undefined;
  let t1;
  if ($[0] !== heightValue || $[1] !== widthValue) {
    t1 = widthValue ?? (heightValue ? Math.round(heightValue * 1.3333333333333333) : 400);
    $[0] = heightValue;
    $[1] = widthValue;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const resolvedWidth = t1;
  let t2;
  if ($[3] !== heightValue || $[4] !== resolvedWidth) {
    t2 = heightValue ?? Math.round(resolvedWidth * 0.75);
    $[3] = heightValue;
    $[4] = resolvedWidth;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const resolvedHeight = t2;
  const loadingStrategy = index === 0 ? "eager" : "lazy";
  let t3;
  if ($[6] !== index || $[7] !== registerImage) {
    t3 = registerImage(index);
    $[6] = index;
    $[7] = registerImage;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== index || $[10] !== markLoaded) {
    t4 = () => {
      markLoaded(index);
    };
    $[9] = index;
    $[10] = markLoaded;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== index || $[13] !== markLoaded || $[14] !== onError) {
    t5 = event => {
      markLoaded(index);
      onError?.(event);
    };
    $[12] = index;
    $[13] = markLoaded;
    $[14] = onError;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== alt || $[17] !== className || $[18] !== loadingStrategy || $[19] !== onClick || $[20] !== resolvedHeight || $[21] !== resolvedWidth || $[22] !== src || $[23] !== style || $[24] !== t3 || $[25] !== t4 || $[26] !== t5) {
    t6 = <Image src={src} alt={alt} width={resolvedWidth} height={resolvedHeight} className={className} style={style} ref={t3} data-loaded="false" data-tweet-media-image={true} onClick={onClick} onLoad={t4} onError={t5} loading={loadingStrategy} unoptimized={true} />;
    $[16] = alt;
    $[17] = className;
    $[18] = loadingStrategy;
    $[19] = onClick;
    $[20] = resolvedHeight;
    $[21] = resolvedWidth;
    $[22] = src;
    $[23] = style;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
  } else {
    t6 = $[27];
  }
  return t6;
}